<template>
    <div class="card">
        <div class="card-content">
            <div class="content">
                <h3>Price</h3>

                <slot></slot>

                <div class="columns is-vcentered">
                    <div class="column is-2">
                        <b-field label="Filter by price">
                            <b-switch v-model="priceRangeEnabled"></b-switch>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="From">
                           <b-input
                                type="number"
                                v-model="fromPrice"
                                :disabled="!priceRangeEnabled"
                                placeholder="0,00"></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="To">
                           <b-input
                                type="number"
                                v-model="toPrice"
                                :disabled="!priceRangeEnabled"
                                placeholder="0,00"></b-input>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "PriceRangeSettings",
    data() {
        return {
            fromPrice: 0.0,
            toPrice: 0.0,
            priceRangeEnabled: false
        }
    },
    methods: {
        isValid() {
            if (!this.priceRangeEnabled) return true;
            return parseInt(this.fromPrice) < parseInt(this.toPrice);
        },
        getPriceRange() {
            if (!this.priceRangeEnabled) return null;

            return [
                parseInt(this.fromPrice),
                parseInt(this.toPrice)
            ];
        }
    }
};

</script>

<style scoped>

</style>